import React from 'react';
import { useGlobalModal } from '../../../../hooks/useGlobalModal';
import { getRoute } from '../../../../services/router';
import UiNavLink from '../../../ui/nav-link/UiNavLink';
import SportMatchOfTheDayCardRulesModal from '../rules-modal/SportMatchOfTheDayCardRulesModal';
import Wrapper from './styles';
import SportOddsLoad from '../../odds/load/SportOddsLoad';
import { isFeatureAvailable } from '../../../../services/feature';
import { FEATURE } from '../../../../services/types';
import Svg from '../../../svg/Svg';
import { translate } from '../../../../services/translate';
import { isUserFromCountry } from '../../../../services/users/country';
import { Country } from '@staycool/location';
import UiButton from '../../../ui/button/UiButton';
import { useSportsMatchContext } from '../../../../services/sports/match-helpers';
import SportMatchOfTheDayCardTurnoverModal from '../turnover-modal/SportMatchOfTheDayCardTurnoverModal';
import { MatchOfTheDay } from '../../../../microservices/match-of-the-day/types';

interface Props {
    market: MatchOfTheDay['market'] & { in_play: boolean; betting_end: Date };
    motd: MatchOfTheDay['motd'];
    matchId: number;
    marketsTotalCount: number;
}
export default function SportMatchOfTheDayCardContent({
    market,
    motd: { match_id, isEligibleForMultiplier, multiplier, isEligibleForBoringMatch },
    matchId,
    marketsTotalCount,
}: Props) {
    const isBoringMatchRefundVisible = !isUserFromCountry(Country.SWEDEN);
    const { showModal, hideModal } = useGlobalModal();
    const { turnoverVisible, setContext } = useSportsMatchContext();
    const toggleTurnoverVisibility = () => setContext?.({ turnoverVisible: !turnoverVisible });

    function openRulesModal() {
        showModal(() => <SportMatchOfTheDayCardRulesModal onClose={hideModal} />, { onClose: hideModal });
    }

    return (
        <>
            <Wrapper>
                <ul>
                    {isEligibleForBoringMatch && (
                        <>
                            {isBoringMatchRefundVisible && (
                                <li>
                                    <Svg icon="top-20" className="list-item-icon" size={0.5} />
                                    <span>{translate('sports.mod.usp2')}</span>
                                </li>
                            )}
                            {isEligibleForMultiplier && (
                                <li>
                                    <Svg icon="multiplier-bonus-ico" className="list-item-icon" size={0.5} />
                                    <span>
                                        {multiplier}% {translate('multiplier-bonus', 'sports.mod')}
                                    </span>
                                </li>
                            )}
                        </>
                    )}
                    {isFeatureAvailable(FEATURE.MATCH_TURNOVER) && (
                        <li>
                            <Svg icon="turnover-ico" className="list-item-icon" size={0.5} />
                            <UiButton
                                type="button"
                                iconPosition="left"
                                className="turnover-btn"
                                onClick={toggleTurnoverVisibility}
                                size="small"
                            >
                                Turnover
                            </UiButton>
                        </li>
                    )}
                </ul>
                <div className="motd-odds">
                    <div className="odds">
                        {market?.outcomes.map((outcome) => (
                            <SportOddsLoad
                                key={outcome.id}
                                outcomeId={outcome.id}
                                market={market}
                                isOutcomeNameVisible
                            />
                        ))}
                    </div>
                    <UiNavLink to={`${getRoute('sport')}/match/${matchId}`} className="more-odds-link">
                        +{marketsTotalCount}
                    </UiNavLink>
                </div>
                <div onClick={openRulesModal} className="terms-and-conditions">
                    {translate('ui.account.terms---conditions')}
                </div>
            </Wrapper>
            <SportMatchOfTheDayCardTurnoverModal
                isOpen={turnoverVisible}
                onClose={() => setContext?.({ turnoverVisible: false })}
                market={market}
                matchId={match_id}
            />
        </>
    );
}
